export class EnterprisePinMaps {
  pinMapId: number;
  enterpriseId: number;
  name: string;
  path: string;
  file: File;
}